import { JarvisLogEntry } from '../types/jarvis.types';

export interface JarvisRequest {
  query?: string;
  context?: string;
}

export interface JarvisResponse {
  status: 'success' | 'error';
  request_id: string;
  briefing: string;
  model_used: string;
  usage: {
    prompt_tokens: number;
    completion_tokens: number;
    total_tokens: number;
    cached_tokens?: number;
  };
  cost: {
    input_cost: number;
    output_cost: number;
    cache_cost?: number;
    total_cost: number;
    currency: string;
  };
  metadata?: {
    documents_processed?: number;
    [key: string]: any;
  };
  error?: string;
}

export class JarvisService {
  private static readonly API_URL = 'https://jarvis-api-eight.vercel.app/api/jarvis';

  /**
   * Get today's briefing from JARVIS
   */
  static async getDailyBriefing(query?: string, context?: string): Promise<JarvisResponse> {
    try {
      const body: JarvisRequest = {};
      if (query) body.query = query;
      if (context) body.context = context;

      const response = await fetch(this.API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const result: JarvisResponse = await response.json();
      return result;
    } catch (error) {
      console.error('Error fetching JARVIS briefing:', error);
      throw error;
    }
  }

  /**
   * Get a default "What should I focus on today?" briefing
   */
  static async getTodayFocus(): Promise<JarvisResponse> {
    return this.getDailyBriefing('What should I focus on today?');
  }

  /**
   * Convert JARVIS response to a log entry format
   */
  static convertToLogEntry(response: JarvisResponse): Partial<JarvisLogEntry> {
    return {
      request_id: response.request_id,
      timestamp: new Date().toISOString(),
      endpoint: '/api/jarvis',
      method: 'POST',
      response_content: response.briefing,
      model_used: response.model_used,
      tokens: response.usage,
      cost: response.cost,
      status: response.status,
      metadata: response.metadata,
    };
  }
}
